.wrapper {
  background: #fef5e7;
}

.backButton {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: #111;
  font-size: 14px;
}

.backButton:hover {
  opacity: 0.8;
}

.backButtonText {
  color: #04051b;
  font-weight: 400;
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  margin-left: 8px;
}

.backIcon {
  width: 6px;
}

.page {
  max-width: 900px;
  margin: 120px auto;
  padding: 24px 24px 80px;
  color: #1c1c1c;
}

.date {
  font-size: 14px;
  text-align: center;
  color: #525252;
  font-weight: 500;
  font-family: 'Poppins', sans-serif;
}

.title {
  font-family: 'Poppins', sans-serif;
  text-align: center;
  font-weight: 600;
  margin-bottom: 32px;
  font-size: 48px;
  line-height: 72px;
  color: #04051b;
}

.subtitle {
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 20px;
  text-align: center;
  line-height: 30px;
  max-width: 720px;
  margin: 0 auto 46px;
  color: #525252;
}

h3 {
  margin-top: 40px;
  margin-bottom: 12px;
  font-size: 18px;
  font-family: 'Poppins', sans-serif;
}

p {
  margin-bottom: 16px;
  font-size: 15px;
  font-family: 'Poppins', sans-serif;
}
